import React, { useMemo, useState } from "react";
import FileSaver from "file-saver";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import moment from "moment";
import { toast } from "react-toastify";
import { Toast } from "../../../../config/Toast";

// Components
import Button from "../../../../components/Button";
import ButtonDropdown from "../../../../components/ButtonDropdown";
import InputGroup from "../../../../components/InputGroup";

// Services
import reportService from "../../../../services/Report";

function SalaryCalculationControls({
  onDateChange,
  handleSearch,
}) {
  const [rangeDate, setRangeDate] = useState([]);
  const [btnExcelLoading, setBtnExcelLoading] = useState(false);
  const notifySuccess = (msg) => toast.success(msg, Toast);
  const notifyFailed = (msg) => toast.error(msg, Toast);

  const getWeeksOfMonth = (year, month) => {
    const weeks = [];
    let current = moment(`${year}-${month}-01`).startOf("month");
    while (current.day() !== 4) current.add(1, "day");
    while (current.month() + 1 === month) {
      const start = current.clone();
      const end = current.clone().add(6, "days");
      weeks.push([start.toDate(), end.toDate()]);
      current.add(7, "days");
    }
    return weeks;
  };

  const currentYear = moment().year();
  const currentMonth = moment().month() + 1;
  const weeks = useMemo(() => getWeeksOfMonth(currentYear, currentMonth), [currentYear, currentMonth]);

  const handleDateChange = (selectedDates, instance) => {
    if (selectedDates.length === 2) {
      const [start, end] = selectedDates;
      notifySuccess(`Tanggal terpilih: ${moment(start).format("DD MMM")} - ${moment(end).format("DD MMM")}`, Toast);
      setRangeDate(selectedDates);
      onDateChange(selectedDates);
    }
  };

  const handleSelectWeek = (index) => {
    const week = weeks[index];
    if (!week) return notifyFailed("Minggu tidak ditemukan.");
    setRangeDate(week);
    onDateChange?.(week);
    notifySuccess(`Tanggal terpilih: ${moment(week[0]).format("DD MMM")} - ${moment(week[1]).format("DD MMM")}`);
  };

  const handleExport = async () => {
    if (!rangeDate[0] || !rangeDate[1]) return notifyFailed("Tanggal wajib diisi");

    const payload = {
      start_date: moment(rangeDate[0]).format("YYYY-MM-DD"),
      end_date: moment(rangeDate[1]).format("YYYY-MM-DD"),
    };

    setBtnExcelLoading(true);
    try {
      const res = await reportService.salaryCalculationExcel(payload)
      const fileUrl =  `${process.env.REACT_APP_API_DOMAIN}/${res.data.path}`

      const response = await fetch(fileUrl)
      if (!response.ok) {
        notifyFailed("File tidak ditemukan");
        return
      }

      const blob = await response.blob();
      FileSaver.saveAs(blob, res.data.path)
      notifySuccess('Berhasil download report upah tukang');
    } catch (err) {
      console.error('Export error:', err);
      notifyFailed(err?.response?.data?.message || "Terjadi kesalahan saat mengunduh");
    } finally {
      setBtnExcelLoading(false);
    }
  };

  const dropdown = [
    { name: "Minggu 1", clickFunction: () => handleSelectWeek(0) },
    { name: "Minggu 2", clickFunction: () => handleSelectWeek(1) },
    { name: "Minggu 3", clickFunction: () => handleSelectWeek(2) },
    { name: "Minggu 4", clickFunction: () => handleSelectWeek(3) },
    { name: "Minggu 5", clickFunction: () => handleSelectWeek(4) },
  ];
  
  const handleSearchInput = (value) => handleSearch?.(value);

  return (
    <div className="d-flex flex-column justify-content-end align-items-end w-100 h-100 gap-3">
      <div className="d-flex justify-content-between align-items-end w-100 gap-3">
        <div className="d-flex align-items-end gap-2 w-100">
          <div className="flex-1">
            <h6 className="fw-bold mb-2">Pilih Rentang Tanggal</h6>
            <Flatpickr
              value={rangeDate}
              options={{ mode: "range", dateFormat: "d-m-Y" }}
              onChange={handleDateChange}
              className="form-control"
              placeholder="Pilih Tanggal Awal dan Akhir"
            />
          </div>
          <ButtonDropdown button="btn-primary" title="Shortcut Date" dropdown={dropdown} />
          <Button
            button="btn-success btn-md"
            title={btnExcelLoading ? "Exporting..." : "Export to Excel"}
            disabled={btnExcelLoading}
            onClick={handleExport}
          />
          
          <div className="w-40">
            <InputGroup button="btn-dark" icon="fa fa-search" placeholder="Cari Project ID/Nama Mitra" searchHandler={handleSearchInput} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SalaryCalculationControls;
